module.exports = __webpack_public_path__ + "img/logo.a9993a71.svg";